export const COMMUNES = [
  { id: 'Saint-Denis', slug: 'saint-denis', name: 'Saint-Denis', region: 'Nord' },
  { id: 'Sainte-Marie', slug: 'sainte-marie', name: 'Sainte-Marie', region: 'Nord' },
  { id: 'Sainte-Suzanne', slug: 'sainte-suzanne', name: 'Sainte-Suzanne', region: 'Nord' },
  { id: 'Saint-André', slug: 'saint-andre', name: 'Saint-André', region: 'Est' },
  { id: 'Bras-Panon', slug: 'bras-panon', name: 'Bras-Panon', region: 'Est' },
  { id: 'Saint-Benoît', slug: 'saint-benoit', name: 'Saint-Benoît', region: 'Est' },
  { id: 'Sainte-Rose', slug: 'sainte-rose', name: 'Sainte-Rose', region: 'Est' },
  { id: 'Plaine-des-Palmistes', slug: 'plaine-des-palmistes', name: 'La Plaine-des-Palmistes', region: 'Est' },
  { id: 'Saint-Pierre', slug: 'saint-pierre', name: 'Saint-Pierre', region: 'Sud' },
  { id: 'Saint-Louis', slug: 'saint-louis', name: 'Saint-Louis', region: 'Sud' },
  { id: 'Saint-Joseph', slug: 'saint-joseph', name: 'Saint-Joseph', region: 'Sud' },
  { id: 'Saint-Philippe', slug: 'saint-philippe', name: 'Saint-Philippe', region: 'Sud' },
  { id: 'Petite-Île', slug: 'petite-ile', name: 'Petite-Île', region: 'Sud' },
  { id: 'Le-Tampon', slug: 'le-tampon', name: 'Le Tampon', region: 'Sud' },
  { id: 'Entre-Deux', slug: 'entre-deux', name: 'Entre-Deux', region: 'Sud' },
  { id: 'Cilaos', slug: 'cilaos', name: 'Cilaos', region: 'Sud' },
  { id: 'Étang-Salé', slug: 'etang-sale', name: "L'Étang-Salé", region: 'Sud' },
  { id: 'Les-Avirons', slug: 'les-avirons', name: 'Les Avirons', region: 'Sud' },
  { id: 'Saint-Paul', slug: 'saint-paul', name: 'Saint-Paul', region: 'Ouest' },
  { id: 'Saint-Leu', slug: 'saint-leu', name: 'Saint-Leu', region: 'Ouest' },
  { id: 'Trois-Bassins', slug: 'trois-bassins', name: 'Trois-Bassins', region: 'Ouest' },
  { id: 'La-Possession', slug: 'la-possession', name: 'La Possession', region: 'Ouest' },
  { id: 'Le-Port', slug: 'le-port', name: 'Le Port', region: 'Ouest' },
  { id: 'Salazie', slug: 'salazie', name: 'Salazie', region: 'Cirques' },
];

export const REGIONS = ['Nord', 'Est', 'Sud', 'Ouest', 'Cirques'];

export const findCommuneBySlug = (slug) => COMMUNES.find((c) => c.slug === slug);
export const communeSlug = (id) => COMMUNES.find((c) => c.id === id)?.slug;
